module.exports = __webpack_public_path__ + "252b833eee63afee120bcd1e74639f9e.svg";